import { Box, Button } from "@material-ui/core";
import { useState } from "react";
import SequencerMixPlaylistCommentsPanel from "./SequencerMixPlaylistCommentsPanel";
import useCommentsPanelStyles from "./SequencerMixCommentsPanel.styles";
import SequencerMixVersionCommentsPanel from "./SequencerMixVersionCommentsPanel";
import useDataViewStyles from "./SequencerMixDataView.styles";

const SequencerMixDataViewRightPanel = ({
  selectedVersion,
  shotsLineUp,
  sequencerDetails,
  currentTime,
  setCurrentTime,
  setSeekToTime,
  isVideoPlaying,
  refreshCounter,
  setRefreshCounter,
  projectId,
  screenshot,
  setScreenshot,
  canvasModal,
  setCanvasModal,
}) => {
  const classes = useDataViewStyles();
  const commentsClasses = useCommentsPanelStyles();
  const [activeTab, setActiveTab] = useState("playlist");

  return (
    <Box className={classes.rightPanel}>
      <Box className={commentsClasses.shell}>
        <Box className={commentsClasses.tabBar}>
          <Button
            className={`${commentsClasses.tabButton} ${activeTab === "playlist" ? commentsClasses.tabButtonActive : ""
              }`}
            onClick={() => setActiveTab("playlist")}
            disableRipple
          >
            Playlist Comments
          </Button>
          <Button
            className={`${commentsClasses.tabButton} ${activeTab === "version" ? commentsClasses.tabButtonActive : ""
              }`}
            onClick={() => setActiveTab("version")}
            disableRipple
          >
            Version Comments
          </Button>
        </Box>

        {activeTab === "playlist" ? (
          <SequencerMixPlaylistCommentsPanel
            selectedVersion={selectedVersion}
            currentTime={currentTime}
            setCurrentTime={setCurrentTime}
            setSeekToTime={setSeekToTime}
            isVideoPlaying={isVideoPlaying}
            refreshCounter={refreshCounter}
            setRefreshCounter={setRefreshCounter}
            projectId={projectId}
            setScreenshot={setScreenshot}
            screenshot={screenshot}
            canvasModal={canvasModal}
            setCanvasModal={setCanvasModal}
            sequencerDetails={sequencerDetails}
            shotsLineUp={shotsLineUp}
          />
        ) : (
          <SequencerMixVersionCommentsPanel
            selectedVersion={selectedVersion}
            currentTime={currentTime}
            isVideoPlaying={isVideoPlaying}
            refreshCounter={refreshCounter}
            setRefreshCounter={setRefreshCounter}
            projectId={projectId}
            setScreenshot={setScreenshot}
            screenshot={screenshot}
            canvasModal={canvasModal}
            setCanvasModal={setCanvasModal}
          />
        )}
      </Box>
    </Box>
  );
};

export default SequencerMixDataViewRightPanel;
